import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { UserIcon, SearchIcon, PlusIcon } from 'lucide-react';
import { PatientList } from '../components/patient/PatientList';
import { PatientDetails } from '../components/patient/PatientDetails';
export function PatientPortal() {
  const [selectedPatientId, setSelectedPatientId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddPatient, setShowAddPatient] = useState(false);
  return <div className="min-h-screen bg-gray-50 w-full" data-id="element-1867">
      <Navigation data-id="element-1868" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1869">
        <div className="flex items-center justify-between mb-6" data-id="element-1870">
          <div className="flex items-center space-x-3" data-id="element-1871">
            <UserIcon className="w-8 h-8 text-green-600" data-id="element-1872" />
            <div data-id="element-1873">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-1874">
                Patient Portal
              </h1>
              <p className="text-gray-600" data-id="element-1875">
                Complete health lifecycle management for all patients
              </p>
            </div>
          </div>
          <button onClick={() => setShowAddPatient(true)} className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700" data-id="element-1876">
            <PlusIcon className="w-5 h-5" data-id="element-1877" />
            <span data-id="element-1878">Add New Patient</span>
          </button>
        </div>
        {/* Search Bar */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6" data-id="element-1879">
          <div className="relative" data-id="element-1880">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1881" />
            <input type="text" placeholder="Search patients by name, phone, or patient ID..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-1882" />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1883">
          {/* Patient List */}
          <div className="lg:col-span-1" data-id="element-1884">
            <PatientList searchTerm={searchTerm} selectedPatientId={selectedPatientId} onSelectPatient={setSelectedPatientId} data-id="element-1885" />
          </div>
          {/* Patient Details */}
          <div className="lg:col-span-2" data-id="element-1886">
            {selectedPatientId ? <PatientDetails patientId={selectedPatientId} data-id="element-1887" /> : <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center" data-id="element-1888">
                <UserIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-1889" />
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1890">
                  No Patient Selected
                </h3>
                <p className="text-gray-500" data-id="element-1891">
                  Select a patient from the list to view their complete record
                </p>
              </div>}
          </div>
        </div>
      </div>
    </div>;
}